var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"profile-nav-menu d-flex justify-content-between text-decoration-none",attrs:{"to":_vm.routePath},nativeOn:{"click":function($event){return _vm.scrollToTop.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.linkName))]),_c('i',{staticClass:"text-right fa fa-caret-right"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }